// headHeadApi.js
import React from 'react';

const HeadHeadApi = ({ pageurl, lang }) => {
  const isStaging = 
    typeof window !== "undefined" &&
    (window.location.href.includes("https://staging-tekrevol.tekstagearea.com") ||
     window.location.href.includes("http://localhost:9000"));

     
  return (
    <>
      <link rel="canonical" href={pageurl} />
      <link rel="alternate" hreflang={lang} href={pageurl} />
      <link rel="alternate" href={pageurl} hreflang="x-default" />
      <meta name="msvalidate.01" content="2E5E301254F9DEB0B72E800F335D24FC" />
      {isStaging && <meta name="robots" content="noindex, nofollow" />}
    </>
  );
};

// Export Head to be used in pages
export const Head = ({ pageurl, lang }) => {
  const isStaging = 
    typeof window !== "undefined" &&
    (window.location.href.includes("https://staging-tekrevol.tekstagearea.com") ||
     window.location.href.includes("http://localhost:9000"));

  return (
    <>
      <link rel="canonical" href={pageurl} />
      <link rel="alternate" hreflang={lang} href={pageurl} />
      <link rel="alternate" href={pageurl} hreflang="x-default" />
      <meta name="msvalidate.01" content="2E5E301254F9DEB0B72E800F335D24FC" />
      {isStaging && <meta name="robots" content="noindex, nofollow" />}
    </>
  );
};

export default HeadHeadApi;